import { render, staticRenderFns } from "./about-us-location.vue?vue&type=template&id=0f32c61a&scoped=true&"
import script from "./about-us-location.vue?vue&type=script&lang=js&"
export * from "./about-us-location.vue?vue&type=script&lang=js&"
import style0 from "./about-us-location.vue?vue&type=style&index=0&id=0f32c61a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32c61a",
  null
  
)

export default component.exports